// DelUtils.js
// Class for helper functions to pull or transform information correctly
import { DEL_UNIT_TYPES } from "../../../constants/delConstants";

export class DelUtils {
  constructor(delInfo, delMode, projects, employeePositions) {
    this.delInfo = delInfo; // Needs to be a Del class first;
    this.delMode = delMode;
    this.allProjectInfo = projects;
    this.allEmployeePositions = employeePositions;
    this.delUnitTypes = DEL_UNIT_TYPES;
  }

  // Function to handle the existing project info being pulled from the database.
  _existingDelProjectInfo = () => {
    // If the project is inactive, we need to add the inactive_project_info to the DelProject object.
    if (this.delInfo.projectInfo.inactiveProjectInfo) {
      this.delInfo.projectInfo.fromExistingDelWithInactiveProject();
    } else {
      this.delInfo.projectInfo.fromExistingDel(this.allProjectInfo);
    }
    return this.delInfo;
  };

  // Function to handle employee shift information coming from a copied del since the shifts come in as empty arrays.
  _handleCopiedDelEmployeeShifts = () => {
    this.delInfo.employees.forEach((employee) => {
      employee.addNewShift(employee.employeeRowId);
    });
  };

  // Function to update the incoming position information for employees in the delInfo list.
  _updateEmployeePositionInfo = () => {
    this.delInfo.employees.forEach((employee) => {
      employee.updateEmployeePositionName(this.allEmployeePositions);
    });
  };

  // Function to update the incoming unit types to the unit type names
  _updateUnitTypeNames = () => {
    this.delInfo.units.forEach((unit) => {
      unit.updateUnitTypeName(this.delUnitTypes[unit.unitType]);
    });
  };

  // Function to handle the copied del field notes, which involves clearing out the existing field notes and adding five blank field notes to the del.
  _handleCopiedDelFieldNotes = () => {
    this.delInfo.fieldNotes.deleteAllActivities();
    for (let i = 0; i < 5; i++) {
      this.delInfo.fieldNotes.addBlankNewActivity();
    }
  };

  // Function to transform the del data
  transformDelData = () => {
    // Setting the project info
    this._existingDelProjectInfo();
    // Setting the employee position info, since most of the employee data will be included in the database call.
    this._updateEmployeePositionInfo();
    // Setting the unit type names
    this._updateUnitTypeNames();
    // Handling the copied del information
    if (this.delMode === "copy") {
      this._handleCopiedDelEmployeeShifts();
      this._handleCopiedDelFieldNotes();
    }
    return this.delInfo;
  };
}
